<template>
  <div>
   <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'ui-radio-group',
  props:{
    val:{default:""},
  },
  data:function(){
    return {
      children:[],
    }
  },
  methods:{
    switchOffAll(){
     this.children.forEach(child=>{
        child.switch_off();
    })
    },
  },
  
  created(){
    
    this.$on('register-ui-radio',(child)=>{
      this.children.push(child);
    })
      
    
    
    this.$on('clicked-ui-radio',(val)=>{

      // emit to event on tag
      this.$emit('input',val);

      // switch all children off
      this.switchOffAll();
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ui-radio-group-container{
  display:inline-flex;
  align-items: center;
  cursor:pointer;
}
.radio{
  display:inline-block;
  border-radius:9999px;
  width:20px;
  height:20px;
  border:1px solid red;
  background-color:#FFFFFF;
  margin-right:5px;
}

.label{
  flex:1;
}

</style>
